module.exports = __webpack_public_path__ + "static/media/left-arrow.3867b79c.svg";